import { render, staticRenderFns } from "./ProjectFiles.vue?vue&type=template&id=4a7c5056&"
import script from "./ProjectFiles.vue?vue&type=script&lang=js&"
export * from "./ProjectFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports